import datasetParser from "@Dataset/datasetParser";
import PortalMap from "@Portals/components/PortalMap";
import Row from "@Containers/components/Row";
import IconRating from "@Icons/IconRating";
import {Colors} from "@Styles/Colors.style";
import Translation from "@Translation/components/Translation";
import React from "react";
import {Transportation} from "@Pages/stationToStation/features/companyCard/components/Transportation";
import useLocale from "@Hooks/selector/useLocale";
import IconArrowAirplane from "@Icons/arrows/IconArrowAirplane";

export const CompanyCard = ({index}: {index?: number}) => {
    const parsedData = datasetParser({id: `company-card-content__${index + 1}`})
    const locale = useLocale();

    return (
        <PortalMap className={`company-card-content__${index + 1}`}>
            <div className="company-name-and-score">
                <h4 className="gb--truncate">
                    {parsedData?.companyName}
                </h4>
                <Row center>
                    {parsedData?.reviews > 0 ? (
                        <>
                            <div style={{marginRight: 10, display: 'flex', alignItems: 'center'}}>
                                <IconRating width={16} height={16} fill={Colors.warningColor} stroke={Colors.warningColor}/>
                                <span style={{fontWeight: 'bold'}}>
                                    {parsedData?.rating}
                                </span>
                            </div>

                            <p>{parsedData?.reviews} reviews</p>
                        </>
                    ) : (
                        <p>
                            <Translation translationKey="sts_page.bus_companies.no_reviews_yet"/>
                        </p>
                    )}
                </Row>
                <h6 className="gb--row gb--row--middle">
                    <Transportation transportType={parsedData?.transportType}/>
                    <span>
                        {parsedData?.routes}
                        {' '}
                        routes
                    </span>
                </h6>
                {parsedData?.link[locale] && parsedData?.link[locale].length > 0 && (
                    <Row>
                        <a href={parsedData?.link[locale]}>
                            <Translation translationKey="sys.see_more"/>
                            <IconArrowAirplane width={18} height={18} fill={Colors.primaryColor}/>
                        </a>
                    </Row>
                )}
            </div>

        </PortalMap>
    )
}